import { useRecordContext } from "ra-core";
import { Coins } from "lucide-react";
import { Badge } from "@/components/ui/badge";
import type { Contact } from "../types";
import { contactCreditSummary } from "../echoflicks/credits";

/**
 * Remaining credit balance (dashboard projection of the bot's balance
 * snapshots). Renders nothing until the contact has reported a balance —
 * the bot emits one on every /create and on every purchase / grant.
 */
export const ContactCreditsInfo = () => {
  const record = useRecordContext<Contact>();
  const summary = contactCreditSummary(record);
  if (!summary) return null;

  return (
    <div className="flex flex-col gap-1">
      <div className="flex items-center gap-2">
        <Badge variant="secondary">
          <Coins className="size-3" />
          {summary.balance.toLocaleString("en-US")} credits
        </Badge>
        {summary.echoesLeft != null ? (
          <span className="text-xs text-muted-foreground">
            ≈ {summary.echoesLeft.toLocaleString("en-US")} echo
            {summary.echoesLeft === 1 ? "" : "es"}
          </span>
        ) : null}
      </div>
      {summary.asOf ? (
        <span className="text-xs text-muted-foreground">
          as of {new Date(summary.asOf).toLocaleString()}
        </span>
      ) : null}
    </div>
  );
};
